// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryJewerly_root__26HoV"};